import React, { useState, useCallback, useEffect } from "react";
import { Fade, Modal } from "@activecollab/components";
import PropTypes from "prop-types";
import { FilePreview } from "./FilePreview.jsx";

export const FilePreviewModal = ({ open: defaultOpen, onClose, ...rest }) => {
  const [open, setOpen] = useState(defaultOpen);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{ zIndex: 15000 }}
    >
      <Fade
        in
        timeout={250}
      >
        <FilePreview
          {...rest}
          onClose={handleClose}
        />
      </Fade>
    </Modal>
  );
};

FilePreviewModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

FilePreviewModal.defaultProps = {
  open: false,
};
